export const elements = {
    hamburger    : document.querySelector('.hamburger-box'),
    backdrop     : document.querySelector('.backdrop'),
    nav          : document.querySelector('.nav'),
    header       : document.querySelector('.wrapper--header'),
    logo         : document.querySelector('.header__logo'),
    btn          : document.querySelector('.btn--grey'),
    btnBox       : document.querySelector('.terms__btn-box'),
    termsBackdrop: document.querySelector('.terms__backdrop'),
    termsLastItem: document.querySelector('.terms__list-item--last'),
    wrapperTerms : document.querySelector('.wrapper--terms'),
    shadow       : document.querySelector('.terms__img-box--shadow'),
    papyrus      : document.querySelector('.terms__img-box--papyrus'),
    stars        : Array.from(document.querySelectorAll('.star'))
}


export const elementsStrings = {
    hamburgerActive    : 'hamburger-box--active',
    backdropActive     : 'backdrop--active',
    backdropTermsActive: 'terms__backdrop--active',
    wrapperTermsActive : 'wrapper--terms-active',
    showTermsItem      : 'terms__list-item--show',
    shadowHidden       : 'terms__img-box--shadow-hidden',
    papyrusOpen        : 'terms__img-box--open',
    navMobile          : 'wrapper--header-mobile',
    navHide            : 'nav--hide',
}